import React from 'react';

const AppNotInstalledMessage = ({ user }) => {
  const handleInstallFromAppSource = () => {
    window.open('https://appsource.microsoft.com/en-us/product/office/wa200004477?tab=overview', '_blank');
  };

  const handleInstallFromTeams = () => {
    // Teams deep link to install the app
    window.open('https://teams.microsoft.com/l/app/6d4c33dc-45bb-473b-92c1-a7b58b3aeea5', '_blank');
  };

  return (
    <div className="app-not-installed-container" style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
            <div className="card shadow-lg border-0" style={{
              borderRadius: '20px',
              overflow: 'hidden'
            }}>
              {/* Header */}
              <div className="card-header text-center" style={{
                background: 'linear-gradient(135deg, #E04F60 0%, #c94456 100%)',
                color: 'white',
                padding: '2rem',
                border: 'none'
              }}>
                <div style={{ marginBottom: '1rem' }}>
                  <i className="fa fa-exclamation-triangle" style={{
                    fontSize: '3rem',
                    opacity: 0.9
                  }}></i>
                </div>
                <h2 style={{
                  fontSize: '1.8rem',
                  fontWeight: '700',
                  marginBottom: '0.5rem',
                  letterSpacing: '-0.025em'
                }}>
                  App Not Installed
                </h2>
                <p style={{
                  fontSize: '1rem',
                  opacity: 0.9,
                  marginBottom: '0'
                }}>
                  Ricotta Games and Trivia is not installed for your organization
                </p>
              </div>

              {/* Body */}
              <div className="card-body" style={{ padding: '2.5rem' }}>
                <div className="text-center mb-4">
                  <h4 style={{
                    color: '#2C3E50',
                    marginBottom: '1rem',
                    fontSize: '1.3rem',
                    fontWeight: '600'
                  }}>
                    Installation Required
                  </h4>
                  <p style={{
                    color: '#6c757d',
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    maxWidth: '500px',
                    margin: '0 auto 2rem auto'
                  }}>
                    To access billing and subscription management, your organization needs to install 
                    <strong style={{ color: '#E04F60' }}> Ricotta Games and Trivia</strong> from Microsoft Teams.
                  </p>
                </div>

                {/* Installation Options */}
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="installation-option" style={{
                      border: '2px solid #e9ecef',
                      borderRadius: '12px',
                      padding: '1.5rem',
                      textAlign: 'center',
                      height: '100%',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer'
                    }}
                    onClick={handleInstallFromTeams}
                    onMouseOver={(e) => {
                      e.currentTarget.style.borderColor = '#E04F60';
                      e.currentTarget.style.backgroundColor = 'rgba(224, 79, 96, 0.02)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.borderColor = '#e9ecef';
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}>
                      <div style={{ marginBottom: '1rem' }}>
                        <i className="fab fa-microsoft" style={{
                          fontSize: '2.5rem',
                          color: '#E04F60'
                        }}></i>
                      </div>
                      <h5 style={{
                        color: '#2C3E50',
                        marginBottom: '0.5rem',
                        fontSize: '1.1rem',
                        fontWeight: '600'
                      }}>
                        Install from Teams
                      </h5>
                      <p style={{
                        color: '#6c757d',
                        fontSize: '0.9rem',
                        marginBottom: '0'
                      }}>
                        Install directly from your Teams desktop application
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="installation-option" style={{
                      border: '2px solid #e9ecef',
                      borderRadius: '12px',
                      padding: '1.5rem',
                      textAlign: 'center',
                      height: '100%',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer'
                    }}
                    onClick={handleInstallFromAppSource}
                    onMouseOver={(e) => {
                      e.currentTarget.style.borderColor = '#E04F60';
                      e.currentTarget.style.backgroundColor = 'rgba(224, 79, 96, 0.02)';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.borderColor = '#e9ecef';
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}>
                      <div style={{ marginBottom: '1rem' }}>
                        <i className="fa fa-store" style={{
                          fontSize: '2.5rem',
                          color: '#E04F60'
                        }}></i>
                      </div>
                      <h5 style={{
                        color: '#2C3E50',
                        marginBottom: '0.5rem',
                        fontSize: '1.1rem',
                        fontWeight: '600'
                      }}>
                        Install from AppSource
                      </h5>
                      <p style={{
                        color: '#6c757d',
                        fontSize: '0.9rem',
                        marginBottom: '0'
                      }}>
                        Get it from Microsoft AppSource marketplace
                      </p>
                    </div>
                  </div>
                </div>


  

                {/* Help Text */}
                <div className="text-center mt-4">
                  <p style={{
                    color: '#95a5a6',
                    fontSize: '0.85rem',
                    marginBottom: '0'
                  }}>
                    Need help with installation? Contact us at{' '}
                    <a 
                      href="mailto:cheese@ricotta.team" 
                      style={{ 
                        color: '#E04F60', 
                        textDecoration: 'none',
                        fontWeight: '500'
                      }}
                    >
                      cheese@ricotta.team
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppNotInstalledMessage;
